<template>
  <ManagerLayout fixed-list>
    <main class="page manager-list-page">
      <header class="page-heading">
        <div><p class="eyebrow">APPOINTMENT</p><h1>科室维护</h1><p class="muted">维护患者预约时可选择的科室。</p></div>
        <button type="button" class="primary" @click="openCreate">新增科室</button>
      </header>
      <p v-if="error" class="error" role="alert">{{ error }}</p>
      <div class="table-wrap">
        <ManagerTable :items="pagedItems" :loading="loading" :error="error" empty-text="暂无科室，请先新增" @retry="load">
          <el-table-column prop="name" label="科室名称" min-width="160" />
          <el-table-column label="科室简介" min-width="260" show-overflow-tooltip><template slot-scope="{ row }">{{ row.introduction || '未填写' }}</template></el-table-column>
          <el-table-column label="状态" min-width="90"><template slot-scope="{ row }"><span :class="['status', row.enabled ? 'on' : 'off']">{{ row.enabled ? '启用' : '停用' }}</span></template></el-table-column>
          <el-table-column label="更新时间" min-width="160"><template slot-scope="{ row }">{{ formatTime(row.updatedAt) }}</template></el-table-column>
          <el-table-column label="操作" width="100" fixed="right"><template slot-scope="{ row }"><button type="button" class="link" @click="openEdit(row)">修改</button></template></el-table-column>
        </ManagerTable>
      </div>
      <ManagerPagination :page="page" :pages="totalPages" :total="items.length" :disabled="loading" @change="changePage" />
      <div v-if="modalOpen" class="overlay" @click.self="closeModal">
        <section class="modal" role="dialog" aria-modal="true">
          <header><h2>{{ editing ? '修改科室' : '新增科室' }}</h2><button type="button" class="close" @click="closeModal">×</button></header>
          <form @submit.prevent="save">
            <label>科室名称<input v-model.trim="form.name" maxlength="80" required></label>
            <label>科室简介<textarea v-model.trim="form.introduction" maxlength="500" rows="4" placeholder="选填"></textarea></label>
            <label class="check"><input v-model="form.enabled" type="checkbox"> 启用该科室</label>
            <p v-if="formError" class="error">{{ formError }}</p>
            <footer><button type="button" class="secondary" @click="closeModal">取消</button><button class="primary" type="submit" :disabled="saving">{{ saving ? '保存中...' : '保存' }}</button></footer>
          </form>
        </section>
      </div>
    </main>
  </ManagerLayout>
</template>

<script>
import ManagerLayout from '@/components/ManagerLayout.vue'
import ManagerTable from '@/components/ManagerTable.vue'
import ManagerPagination from '@/components/ManagerPagination.vue'
import TableColumn from 'element-ui/lib/table-column'
import { listDepartments, createDepartment, updateDepartment } from '@/api/appointment'

export default {
  name: 'DepartmentManagement',
  components: { ManagerLayout, ManagerTable, ManagerPagination, 'el-table-column': TableColumn },
  data () {
    return { items: [], page: 0, pageSize: 20, loading: false, error: '', modalOpen: false, saving: false, formError: '', editing: null, form: { name: '', introduction: '', enabled: true } }
  },
  computed: {
    pagedItems () { return this.items.slice(this.page * this.pageSize, (this.page + 1) * this.pageSize) },
    totalPages () { return Math.ceil(this.items.length / this.pageSize) }
  },
  created () { this.load() },
  methods: {
    async load () {
      this.loading = true; this.error = ''
      try { this.items = await listDepartments() } catch (error) { this.error = error.message || '加载科室失败' } finally { this.loading = false }
    },
    openCreate () { this.editing = null; this.form = { name: '', introduction: '', enabled: true }; this.formError = ''; this.modalOpen = true },
    openEdit (item) { this.editing = item; this.form = { name: item.name, introduction: item.introduction || '', enabled: item.enabled }; this.formError = ''; this.modalOpen = true },
    closeModal () { if (!this.saving) this.modalOpen = false },
    async save () {
      this.formError = ''; this.saving = true
      try {
        const saved = this.editing ? await updateDepartment(this.editing.id, this.form) : await createDepartment(this.form)
        if (this.editing) Object.assign(this.editing, saved); else this.items.push(saved)
        this.items.sort((a, b) => a.name.localeCompare(b.name, 'zh-CN')); this.page = 0; this.modalOpen = false
      } catch (error) { this.formError = error.message || '保存失败' } finally { this.saving = false }
    },
    formatTime (value) { return value ? value.replace('T', ' ').slice(0, 16) : '未填写' },
    changePage (page) { this.page = page }
  }
}
</script>

<style scoped>
.page { display:flex; flex-direction:column; height:calc(100vh - 64px); min-height:0; overflow:hidden; padding:32px; }
.page-heading { display:flex; align-items:flex-start; justify-content:space-between; gap:24px; margin-bottom:26px; }
.eyebrow { margin:0 0 7px; color:#73918e; font-size:11px; letter-spacing:1px; }
h1 { margin:0; color:#18333a; font-size:27px; }
.muted { margin:8px 0 0; color:#839596; font-size:13px; }
.primary,.secondary,.link,.close { cursor:pointer; font:inherit; }
.primary { border:0; border-radius:5px; padding:11px 18px; color:#fff; background:#237f78; }
.primary:disabled { opacity:.55; cursor:wait; }
.secondary { border:1px solid #d6e1de; border-radius:5px; padding:10px 17px; color:#496467; background:#fff; }
.link { padding:5px 0; border:0; color:#237f78; background:transparent; }
.error { margin:0 0 16px; color:#ad554f; font-size:13px; }
.table-wrap { flex:1; min-width:0; min-height:0; overflow:auto; }
.pagination { display:flex; align-items:center; justify-content:flex-end; gap:10px; margin-top:16px; color:#728789; font-size:12px; }
.pagination button { height:34px; padding:0 12px; border:1px solid #d6e1de; border-radius:5px; color:#496467; background:#fff; cursor:pointer; font:inherit; }
.pagination button:disabled { opacity:.5; cursor:default; }
.status { display:inline-block; padding:4px 9px; border-radius:20px; font-size:12px; }
.status.on { color:#147566; background:#e4f3ee; }
.status.off { color:#8c6a53; background:#f6eee5; }
.overlay { position:fixed; inset:0; z-index:30; display:flex; align-items:center; justify-content:center; padding:20px; background:rgba(20,39,43,.38); }
.modal { width:min(480px,100%); border-radius:7px; background:#fff; box-shadow:0 16px 50px rgba(15,40,44,.18); }
.modal header { display:flex; justify-content:space-between; padding:22px 25px 18px; border-bottom:1px solid #e7eeeb; }
.modal h2 { margin:0; color:#18333a; font-size:20px; }
.close { border:0; color:#718587; background:transparent; font-size:25px; }
.modal form { display:grid; gap:17px; padding:23px 25px 25px; }
label { display:grid; gap:8px; color:#496467; font-size:13px; }
input,textarea { width:100%; padding:10px 12px; border:1px solid #d6e1de; border-radius:5px; color:#18333a; background:#fff; font:inherit; outline:0; }
input:focus,textarea:focus { border-color:#237f78; box-shadow:0 0 0 3px rgba(35,127,120,.12); }
.check { display:flex; align-items:center; gap:8px; }
.check input { width:auto; }
.modal footer { display:flex; justify-content:flex-end; gap:10px; margin-top:5px; }
@media (max-width:900px) { .page { height:100vh; padding:24px 18px 16px; } .page-heading { margin-bottom:20px; } }
@media (max-width:640px) { .page-heading { flex-direction:column; gap:16px; } .page-heading .primary { align-self:flex-start; } }
</style>
